import * as carsService from '../../services/cars.service';

const state = {
    carsSingle:{},
    carsPaginateData:{},
    carsPaginate:{},
};

const getters = {
    getCarsSingle:state => (state.carsSingle),
    getCarsPaginateData:state => (state.carsPaginateData),
    getCarsPaginate:state => (state.carsPaginate),
};

const actions = {
    async fetchCarsSingle({ commit }, id){
        try {

          const response = await carsService.single(id);

          console.log(response.data);
          commit('setCarsSingle', response.data);

        } catch (error) {
            console.log('something wrong - fetchCarsSingle', error);
        }
    },

    async fetchCarsPaginate({ commit }, obj){
        commit('setCarsPaginate', obj)
        try {

            const response = await carsService.listPage(obj);
            commit('setCarsPaginateData', response.data);
            
        } catch (error) {
            console.log('something wrong - fetchCarsPaginate', error);
        }
    },
};

const mutations = {
    setCarsSingle:(state, res) => (
        state.carsSingle =  res
    ),
    setCarsPaginateData:(state, res) => (
        state.carsPaginateData =  res
    ),
    setCarsPaginate:(state, res) => (
        state.carsPaginate =  res
    ),
};

export default{
    state,
    getters,
    actions,
    mutations,
}